/* przestarzały plugin ci-mobile-menu zamieniony na moduł (kompatybilność wsteczna) + lekko zmodyfikowany */

export const MobileMenu = function(configObject) {
    var _me = this;      
    var config = {
        autoInit: true,
        lazyInit: false,
        maxScreenSize: 1024,
        menuBoxSelector: '#ci-mobile-menu',
        menuTriggerSelector: '#ci-mobile-menu-trigger',  
        menuCloseBtnSelector: '#ci-mobile-menu-close-btn',
        hasSubmenuClass: 'ci-mobile-menu-has-submenu',
        submenuClass: 'ci-mobile-menu-submenu',
        submenuLinkClass: 'ci-mobile-menu-submenu-link',
        submenuBoxClass: 'ci-mobile-menu-submenu-box',
        activeClass: 'is-active',
        backButton: '<button class="ci-mobile-menu-back-btn" type="button">powrót</button>',
        pageCoverClass: 'ci-mobile-menu-page-cover',
        pageCoverParentSelector: 'body',
        onClose: $.noop,
        onOpen: $.noop
    };
    
    _me.initiated = false;
    _me.lazyInitiated = false;
    _me.menuToAdd = [];
    _me.screenSize = 0;
    _me.lastScreenSize = 0;
    
    if (typeof configObject === 'object') {
        $.extend(config, configObject);
    }
    
    var _lazyInit = function() {
        var initOnResize = function() {
            if ($('body').width() <= config.maxScreenSize) {
                _me.init();
                $(window).off('resize', initOnResize);
            }
        };
        _me.lazyInitiated = true;
        $(window).resize(initOnResize);
        initOnResize();
    };
    
    _me.attachMenu = function(menuDataObject) {    
        var $menu;
        
        if (menuDataObject.menu instanceof jQuery) {
            $menu = menuDataObject.menu.clone();
        } else {
            $menu = $(menuDataObject.menu).clone();
        }
        $menu.removeClass();
        $menu.addClass(config.submenuClass);
        
        menuDataObject.menu = $menu;
        _me.menuToAdd.push(menuDataObject);
    }; 
    
    _me.init = function() {
        if (_me.initiated) return false;
        
        if (config.lazyInit && !_me.lazyInitiated) {
            _lazyInit();
            
            return true;
        }
        
        var $hasSubmenu, $submenu;
        
        _me.$menuBox = $(config.menuBoxSelector);
        _me.$menuTrigger = $(config.menuTriggerSelector);
        _me.$menuCloseBtn = $(config.menuCloseBtnSelector);
        
        if (_me.menuToAdd.length > 0) {  
            for (var i = 0, len = _me.menuToAdd.length; i < len; i++) {                 
                if (_me.menuToAdd[i].existingPosition !== undefined) {
                    var $existingPosition = $(_me.menuToAdd[i].existingPosition);
                    
                    $existingPosition.addClass(config.hasSubmenuClass);
                    $existingPosition.children('a').addClass(config.submenuLinkClass);
                    $existingPosition.append(_me.menuToAdd[i].menu);
                } else {
                    var $targetObject, $newMenuPosition;
                    
                    if (_me.menuToAdd[i].target !== undefined) {
                        $targetObject = _me.$menuBox.find(_me.menuToAdd[i].target);                     
                    } else {
                        $targetObject = _me.$menuBox.children('ul').first();
                    }
                    $newMenuPosition = $('<li class="ci-mobile-menu-hide-position ' + config.hasSubmenuClass + '"></li>');
                    $newMenuPosition.append('<a class="ci-mobile-menu-prevent-clone ' + config.submenuLinkClass + '" href="#">' + _me.menuToAdd[i].title + '</a>');
                    $newMenuPosition.append(_me.menuToAdd[i].menu);
                    
                    if (_me.menuToAdd[i].index !== undefined) {
                        $targetObject.children('li').each(function(index) {
                            if (index === _me.menuToAdd[i].index - 1) {
                                $(this).before($newMenuPosition);
                            
                                return true;
                            }
                        });
                    } else {
                        $targetObject.append($newMenuPosition);
                    }
                }
            }
            
            _me.$newPositions = $('.ci-mobile-menu-hide-position');
        }
        
        $hasSubmenu = _me.$menuBox.find('.' + config.hasSubmenuClass);
        $submenu = _me.$menuBox.find('.' + config.submenuClass);
        
        $submenu.each(function() {
            var $currentSubmenu = $(this);
            var $submenuLink = $currentSubmenu.siblings('.' + config.submenuLinkClass);
            var $newWrapper;
            var $newBackBtn;
                          
            $currentSubmenu.wrap('<div class="' + config.submenuBoxClass + '"></div>');
            $newWrapper = $currentSubmenu.parent('.' + config.submenuBoxClass);
            if (!$submenuLink.hasClass('ci-mobile-menu-prevent-clone')) {
                $newWrapper.prepend('<a class="' + config.submenuLinkClass + '-clone" href="' + $submenuLink.attr('href') + '">' + ($submenuLink.data('text') ? $submenuLink.data('text') : $submenuLink.html()) + '</a>');
            }
            $newBackBtn = $(config.backButton);
            $newBackBtn.on('click', function() {
                $(this).parent('.' + config.submenuBoxClass).removeClass(config.activeClass);
            });
            $newWrapper.prepend($newBackBtn);
        });
        _me.$submenuBoxes = _me.$menuBox.find('.' + config.submenuBoxClass);
        
        $hasSubmenu.children('.' + config.submenuLinkClass).on('click', function(e) {
            if ($('body').width() <= config.maxScreenSize) {
                e.preventDefault();
                $(this).siblings('.' + config.submenuBoxClass).addClass(config.activeClass);
            }
        });
        
        _me.$pageCover = $('<div class="' + config.pageCoverClass + '"></div>');
        $(config.pageCoverParentSelector).append(_me.$pageCover);
        
        _me.$menuTrigger.on('click', function() {
            $('body').addClass('ci-mobile-menu-body-lock');
            _me.$menuBox.addClass(config.activeClass);
            _me.$pageCover.fadeIn(200);
            config.onOpen();
        });
        
        _me.$menuCloseBtn.on('click', function() {
            $('body').removeClass('ci-mobile-menu-body-lock');
            _me.$menuBox.removeClass(config.activeClass);
            _me.$submenuBoxes.removeClass(config.activeClass);
            _me.$pageCover.fadeOut(200);
            config.onClose();
        });
        
        _me.$pageCover.on('click', function() {
            _me.$menuCloseBtn.trigger('click');
        });
        
        var mobileMenuResize = function() {
            _me.screenSize = $('body').width();
            
            if (_me.screenSize !== _me.lastScreenSize) {
                _me.$menuCloseBtn.trigger('click');
            
                if (_me.$newPositions !== undefined) {
                    if (_me.screenSize <= config.maxScreenSize) {
                        _me.$newPositions.show();
                    } else {
                    _me.$newPositions.hide();
                    }
                } 
                
                _me.lastScreenSize = _me.screenSize;
            }                        
        };
        
        $(window).resize(mobileMenuResize);
        mobileMenuResize();
        
        _me.initiated = true;
    };
    
    if (config.autoInit) {
        _me.init();
    }
};